import { PageLayoutContent } from '@crehana/compass.web/page-layout';

import { ComplianceLoadingSkeleton } from './components/compliance-loading-skeleton';

export const AdminLegalAlertsMexicoLoading = () => {
  return (
    <PageLayoutContent className="tw-py-3.2">
      <ComplianceLoadingSkeleton />
    </PageLayoutContent>
  );
};
